import Vue from "vue";
import Vuex from "vuex";
import settings from "./modules/settings";
import modals from "./modules/modals";
import guests from "./modules/guests";
import users from "./modules/users";
import menus from "./modules/menus";
import cart from "./modules/cart";
import notifications from "./modules/notifications";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    state: {
        appProcessing: false,
        apiError: null,
        systemFontsLoaded: false,
        userFontLoaded: false,
    },
    getters: {},
    actions: {
        setAppProcessing({ commit }, value) {
            commit("saveAppProcessing", value);
        },
        setSystemFontsLoaded({ commit }, value) {
            commit("saveSystemFontsLoaded", value);
        },
        setUserFontLoaded({ commit }, value) {
            commit("saveUserFontLoaded", value);
        },
    },
    mutations: {
        saveAppProcessing(state, value) {
            state.appProcessing = value;
        },
        saveApiError(state, value) {
            state.apiError = value;
        },
        saveSystemFontsLoaded(state, value) {
            state.systemFontsLoaded = value;
        },
        saveUserFontLoaded(state, value) {
            state.userFontLoaded = value;
        },
    },
    modules: {
        users,
        cart,
        settings,
        modals,
        guests,
        menus,
        notifications,
    },
    strict: debug,
});
